module.exports = __webpack_public_path__ + "img/educacao2.4e438c98.svg";